import { render, staticRenderFns } from "./ProductActive.vue?vue&type=template&id=46d838b6&scoped=true&"
import script from "./ProductActive.vue?vue&type=script&lang=js&"
export * from "./ProductActive.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46d838b6",
  null
  
)

export default component.exports